import { getTelegramUser } from '../api';
import { getPlatform } from '../platform';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Дедупликация: не отправляем одно и то же событие дважды за сессию
const sentEvents = new Set();

const WEB_CLIENT_ID_KEY = 'stems_web_cid';

// Идентификатор веб-устройства. На сайте другого нет: гость не авторизован, а
// у авторизованного identity живёт в JWT, который фронт не разбирает. Без этого
// (до 17.08.2026) события с сайта не писались вовсе — как и события Max.
export function getWebClientId() {
  try {
    let cid = localStorage.getItem(WEB_CLIENT_ID_KEY);
    if (!cid) {
      cid = (crypto.randomUUID && crypto.randomUUID()) ||
        `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(WEB_CLIENT_ID_KEY, cid);
    }
    return cid;
  } catch (e) {
    return null; // приватный режим / запрет storage — событие просто не уйдёт
  }
}

export function trackEvent(eventType, metadata = null) {
  const user = getTelegramUser();
  const platform = getPlatform();

  // Идентификатор ровно один — по платформе, откуда пришло событие
  const identity = {};
  if (platform === 'telegram' && user?.telegram_id) {
    identity.telegram_id = user.telegram_id;
  } else if (platform === 'max' && user?.max_id) {
    identity.max_id = user.max_id;
  } else if (platform === 'web') {
    identity.web_client_id = getWebClientId();
  }
  if (!identity.telegram_id && !identity.max_id && !identity.web_client_id) return;

  // Эти события — 1 раз за сессию
  const oncePerSession = ['catalog_opened', 'checkout_started', 'cart_opened'];
  if (oncePerSession.includes(eventType)) {
    if (sentEvents.has(eventType)) return;
    sentEvents.add(eventType);
  }

  const { lat, lon, ...restMetadata } = metadata || {};
  const body = {
    event_type: eventType,
    ...identity,
    platform,
    username: user?.username || null,
    first_name: user?.first_name || null,
    last_name: user?.last_name || null,
    lat: lat ?? null,
    lon: lon ?? null,
  };
  if (Object.keys(restMetadata).length > 0) {
    body.metadata = restMetadata;
  }

  // JWT — чтобы бэкенд связал веб-событие с карточкой клиента (user_id).
  // Для TG/Max он не нужен: там identity уже в самом событии.
  const headers = { 'Content-Type': 'application/json' };
  if (platform === 'web') {
    const jwt = localStorage.getItem('stems_jwt');
    if (jwt) headers['Authorization'] = `Bearer ${jwt}`;
  }

  fetch(`${API_URL}/analytics/event`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  }).catch(() => {}); // fire-and-forget
}
